import { ConsultationRecording } from '../config';

type MergeRecordingsParams = {
  incoming: ConsultationRecording[];
  existing: ConsultationRecording[];
  isStillProcessing: boolean;
};

/**
 * While the pipeline is running the server may answer with a fragment whose
 * transcript is not attached yet. Dropping the chunks we already hold would
 * blank out text the user is reading, so they are carried over per recording
 * until the consultation succeeds.
 */
export const mergeRecordings = ({
  incoming,
  existing,
  isStillProcessing,
}: MergeRecordingsParams): ConsultationRecording[] => {
  if (!isStillProcessing || existing.length === 0) {
    return incoming;
  }

  if (incoming.length === 0) {
    return existing;
  }

  const previousChunksById = Object.fromEntries(
    existing.map((recording) => [recording.id, recording.chunks]),
  );

  return incoming.map((recording) => {
    const previousChunks = previousChunksById[recording.id] ?? [];

    if (recording.chunks.length > 0 || previousChunks.length === 0) {
      return recording;
    }

    return { ...recording, chunks: previousChunks };
  });
};
